import { render, staticRenderFns } from "./holesAndSlotsDetail.vue?vue&type=template&id=54a0606e&scoped=true&"
import script from "./holesAndSlotsDetail.vue?vue&type=script&lang=js&"
export * from "./holesAndSlotsDetail.vue?vue&type=script&lang=js&"
import style0 from "./holesAndSlotsDetail.vue?vue&type=style&index=0&id=54a0606e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a0606e",
  null
  
)

export default component.exports